const { __, _x, _n, _nx } = wp.i18n;

/**
 * Integrates chatbot
 */
export default class Chatbot {
	constructor() {
		this.url = window.location.origin + '/chatbot';
		// this.url = 'https://iportal.avato.net/chatbot';
		var script = document.createElement( 'script' );
		script.onload = this.init.bind( this );
		script.src = this.url + '/assets/modules/channel-web/inject.js';
		document.head.appendChild( script );
	}

	init() {
		var self = this;
		if ( ! window.botpressWebChat ) {
			return;
		}

		window.addEventListener( 'message', function (e) {
			if ( e.data.name === 'webchatOpened' ) {
				const start = sessionStorage.getItem( 'chatOpen' ) || false;
				if ( ! start ) {
					// Let the bot talk first after opening.
					window.botpressWebChat.sendEvent( {
						type: 'proactive-trigger',
						channel: 'web',
					});
					sessionStorage.setItem( 'chatOpen', true );
					return;
				}
			}

			switch ( e.data.type ) {
			case 'search':
				// Show search result dialog.
				var dialog = jQuery(
					`<div class="bp-search-result-dialog">
						<iframe></iframe>
					</div>`
				);
				dialog.find( 'iframe' ).attr(
					'src',
					`${e.data.src}`
				);
				dialog.dialog( {
					title: __( 'Search result for:', 'iportal-core' ) + e.data.payload,
					modal: true,
					height: 700,
					width: 780,
				});
				break;
			case 'drag':
				// Start dragging mode.
				self.initDragInfo();
				jQuery( '#bp-web-widget' ).addClass( 'bp-web-widget--draggable' );
			default:
			};

		}, false );

		window.botpressWebChat.init( {
			host: this.url,
			botId: 'lii-bot',
			botAvatarUrl: null,
			botConvoDescription: '',
		} );

		jQuery( '#bp-widget' ).addClass( 'modal-open-fix--add-margin' );
	};

	initDragInfo() {
		if ( ! this.dragInfo ) {
			jQuery( '#bp-web-widget' )
				.draggable()
				.resizable(
					{
						minWidth: 360,
						minHeight: 500,
					}
				);
			this.dragInfo = jQuery(
				`<div class="bp-web-widget__drag-info">
					You can now move and resize this window. <br />Click
					<a href="#">close</a>
					to return to chat.
				</div>`
			);
			this.dragInfo.find( 'a' ).on( 'click', ( e ) => {
				e.preventDefault();
				jQuery( '#bp-web-widget' ).removeClass( 'bp-web-widget--draggable' );
			} );
			jQuery( '#bp-web-widget' ).append( this.dragInfo );
		}
	};
};
